import React from "react";
import ConvertKitForm from "convertkit-react";
import "./ConvertKit.css";

const CONVERT_KIT_FORM_DATA = {
  "member-subscribe": {
    Id: 1983173,
    title: "Member Notifications",
    submitText: "Subscribe for notifications",
  },
  "shareholder-subscribe": {
    Id: 1983176,
    title: "Shareholder Newsletter",
    submitText: "Subscribe for updates",
  },
  "developer-subscribe": {
    Id: 1983167,
    title: "Developer Newsletter",
    submitText: "Subscribe for newsletter",
  },
  "genc-snacks": {
    Id: 1983151,
    title: "GenC Snacks Newsletter",
    submitText: "Subscribe for newsletter",
  },
};

export default function ConvertKitSubscribeForm(props) {
  return (
    <div>
      <h3 className="ck-fm-header">
        {CONVERT_KIT_FORM_DATA[props.formName] !== "undefined"
          ? CONVERT_KIT_FORM_DATA[props.formName].title
          : "Subscribe to newsletter"}
      </h3>
      <ConvertKitForm
        formId={
          CONVERT_KIT_FORM_DATA[props.formName] !== "undefined"
            ? CONVERT_KIT_FORM_DATA[props.formName].Id
            : 1576759
        }
        className="ck-fm"
        submitText={
          CONVERT_KIT_FORM_DATA[props.formName] !== "undefined"
            ? CONVERT_KIT_FORM_DATA[props.formName].submitText
            : "Submit"
        }
      />
    </div>
  );
}
